module.exports = __webpack_public_path__ + "media/assets/icons/quill/align-center-f07b19670defc9d995ad6547b98869ae.svg";